const groupColor = {
  "rejunte": "#9ACA3C",
  "colante": "#900C3F",
  "cimento": "#034EA2",
  "basicas-granel": "#1ABC9C",
  "basicas-ensacado": "#0D6B59", 
  "cales": "#FFC300",
  "impermeabilizante": "#8E44AD",
  "rejeito agregados": "#DAF7A6",
  "concreto": "#00AEEF",
  "rejuntes": "#9ACA3C",
  "colantes": "#900C3F",
  "cales": "#FFC300",
  "impermeabilizantes": "#8E44AD",
  "rejeito agregados": "#DAF7A6",
  "agregados": "#BDBDBD",
};

const statusColor = {
  "em-negociacao": "#034EA2",
  "perdida": "#E2231A",
  "ganha": "#0DB14B",
  "finalizado": "#145A32",
};

const fallbackPalette = [
  "#E91E8C", "#16A085", "#D35400", "#C0392B", "#2980B9",
  "#27AE60", "#F39C12", "#7F8C8D", "#2C3E50", "#E67E22",
  "#9B59B6", "#34495E", "#F1C40F", "#E74C3C", "#3498DB",
  "#2ECC71", "#A93226", "#6C3483", "#117A65", "#AF601A",
  "#1F618D", "#196F3D", "#7D6608", "#CD6155", "#48C9B0",
  "#5DADE2", "#F5B041", "#DC7633", "#7FB3D5", "#73C6B6",
  "#BB8FCE", "#85929E", "#A04000", "#922B21", "#145A32",
  "#4A235A",
];

const getFallbackColor = (key) => {
  const hash = [...String(key)].reduce(
    (acc, char) => acc + char.charCodeAt(0),
    0
  );

  return fallbackPalette[hash % fallbackPalette.length];
};

export const resolveColor = (key, index, groupId, label) => {
  if (statusColor[key]) return statusColor[key];
  if (!label) return groupColor[key] ?? getFallbackColor(groupId);

  const lowerLabel = label.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");

  if (lowerLabel.includes("basica")) {
    if (lowerLabel.includes("ensacado")) return groupColor["basicas-ensacado"];
    return groupColor["basicas-granel"];
  }

  const matchedKey = Object.keys(groupColor).find(k => lowerLabel.includes(k));
  if (matchedKey) return groupColor[matchedKey];

  return groupColor[key] ?? getFallbackColor(groupId);
};
